export default __webpack_public_path__ + "static/media/Visa.af434f50.svg";